<template>
  <div>
    <div class="banner">
      <div class="text wow slideInDown">
        <h2>社交时代，我们为企业赋能</h2>
        <p>稳定、高效、专业、微信最好的生产力工具</p>
      </div>
    </div>
    <div class="part1">
      <div class="wrapper">
        <el-row :gutter="30">
          <el-col :span="12">
            <el-card shadow="hover">
              <img src="" alt width="100%" />
              <div class="post">
                <h3 class="title">关于我们</h3>
                <div class="bottom clearfix info">
                  <p>
                    E云管家创始团队集合 70、80、90后优越资质，拥有着
                    15年成熟的企业服务市场行业经验，同时还拥有着年轻热血的干劲以及先进的技术
                  </p>
                  <br />
                  <p>
                    我们已经进入了社交商业时代，产能过剩，产品同质化程度高，传统的营销手段和广告媒介已经越来越缺乏流量红利，我们的使命就是帮助企业在社交商业时代取得成功。
                  </p>
                  <br />
                  <p>
                    为各企业提供便捷专业的微信管理系统，为企业赋能，为广大传统企业向社交电商新零售转型提供全方位支持，让企业大步跨入社交电商行业！
                  </p>
                  <br />
                  <p>
                    从成立之初，就承载了母公司雄厚的技术积淀和市场积累，以跳跃式的发展速度，成为了社交电商专家，社交商业时代的赋能者。
                  </p>
                </div>
              </div>
            </el-card>
          </el-col>
          <el-col :span="12">
            <el-card shadow="hover">
              <img src="" alt width="100%" />
              <div class="post post-style">
                <h3 class="title">企业文化</h3>
                <div class="bottom clearfix info">
                  <p><span class="red">我们的使命：</span></p>
                  <p>全心全意为企业服务</p>
                  <p>潜心钻研为客户创造价值</p>
                  <br />
                  <p><span class="red">我们的经营理念：</span></p>
                  <p>爱心、信心、决心、融合、责任、进步、</p>
                  <p><span class="red">我们的价值观：</span></p>

                  <p>先做人，后做事</p>
                  <br />
                  <p><span class="red">我们的团队心诀：</span></p>
                  <p>一家人、一个梦 ，一起拼、一定赢</p>
                  <p></p>
                  <p><span class="red">我们的行为准则：</span></p>
                  <p>绝对服从、坚决执行，有命必复、有命必达</p>
                  <p></p>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>
    </div>
    <div id="chart_example"></div>
  </div>
</template>

<script>
import { wowAnimation } from "assets/js/mixin";
import axios from "axios";
// 主模块
let echarts = require("echarts/lib/echarts");
// 散点图
require("echarts/lib/chart/scatter");
// 散点图放大
require("echarts/lib/chart/effectScatter");
// 地图
require("echarts/lib/chart/map");
// 图例
require("echarts/lib/component/legend");
// 提示框
require("echarts/lib/component/tooltip");
// 地图geo
require("echarts/lib/component/geo");
// 中国地图
require("echarts/map/js/china");

export default {
  name: "about",
  mixins: [wowAnimation],
  data() {
    return {
      showCityNumber: 5,
      showCount: 0,
    };
  },
  mounted() {
    let myChart = echarts.init(document.getElementById("chart_example"));
    let option = {
      backgroundColor: "#fff",
      // 标题
      title: {
        text: "我们的客户分布全国各地",
        left: "center",
        textStyle: {
          color: "#303133",
          fontSize: 34,
        },
      },
      // 地图上圆点的提示
      tooltip: {
        trigger: "item",
        formatter: function (params) {
          return params.name + " : " + params.value[2];
        },
      },
      // 图例按钮 点击可选择哪些不显示
      legend: {
        orient: "vertical",
        left: "left",
        top: "bottom",
        data: ["地区热度", "top5"],
        textStyle: {
          color: "#303133",
        },
      },
      // 地理坐标系组件
      geo: {
        map: "china",
        label: {
          // true会显示城市名
          emphasis: {
            show: true,
          },
        },
        itemStyle: {
          // 地图背景色
          normal: {
            areaColor: "#465471",
            borderColor: "#282F3C",
          },
          // 悬浮时
          emphasis: {
            areaColor: "#8796B4",
          },
        },
      },
      // 系列列表
      series: [
        {
          name: "地区热度",
          // 表的类型 这里是散点
          type: "scatter",
          // 使用地理坐标系，通过 geoIndex 指定相应的地理坐标系组件
          coordinateSystem: "geo",
          data: [],
          // 标记的大小
          symbolSize: 12,
          // 鼠标悬浮的时候在圆点上显示数值
          label: {
            normal: {
              show: false,
            },
            emphasis: {
              show: false,
            },
          },
          itemStyle: {
            normal: {
              color: "#ddb926",
            },
            // 鼠标悬浮的时候圆点样式变化
            emphasis: {
              borderColor: "#fff",
              borderWidth: 1,
            },
          },
        },
        {
          name: "top5",
          // 表的类型 这里是散点
          type: "effectScatter",
          // 使用地理坐标系，通过 geoIndex 指定相应的地理坐标系组件
          coordinateSystem: "geo",
          data: [],
          // 标记的大小
          symbolSize: 12,
          showEffectOn: "render",
          rippleEffect: {
            brushType: "stroke",
          },
          hoverAnimation: true,
          label: {
            normal: {
              show: false,
            },
          },
          itemStyle: {
            normal: {
              color: "#f4e925",
              shadowBlur: 10,
              shadowColor: "#333",
            },
          },
          zlevel: 1,
        },
      ],
    };
    myChart.setOption(option);
    this.fetchHeatChinaRealData(myChart);
  },
  methods: {
    fetchHeatChinaRealData(chartsObj) {
      axios.get("/data/heatChinaRealData.json").then((res) => {
        let data = res.data;
        let paleData = ((data) => {
          let arr = [];
          let len = data.length;
          while (len--) {
            let geoCoord = this.$store.state.geoCoordMap[data[len].name];
            if (geoCoord) {
              arr.push({
                name: data[len].name,
                value: geoCoord.concat(data[len].value),
              });
            }
          }
          return arr;
        })(data);
        let lightData = paleData
          .sort((a, b) => {
            return b.value - a.value;
          })
          .slice(0 + this.showCount, this.showCityNumber + this.showCount);
        chartsObj.setOption({
          series: [
            {
              name: "地区热度",
              data: paleData,
            },
            {
              name: "top5",
              data: lightData,
            },
          ],
        });
        this.addCount();
      });
    },
    addCount() {
      this.showCount++;
      // test
      if (this.showCount >= 70) {
        this.showCount = 1;
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
#chart_example {
  width: 100%;
  height: 500px;
}

.banner {
  position: relative;
  height: 11.3rem;
  background: url('../../assets/images/about/banner1.png') 50% 50% repeat;

  &:before {
    content: '';
    display: block;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.2);
    position: absolute;
    left: 0;
    top: 0;
  }

  .text {
    color: #fff;
    position: absolute;
    top: calc(50% - 2rem);
    left: 0;
    width: 100%;
    text-align: center;
    font-size: 0.77rem;
    line-height: 1.3rem;

    h2 {
      font-size: 1rem;
      line-height: 1.7rem;
    }
  }
}

.part1 {
  margin: 30px 0;

  .title {
    font-size: 0.63rem;
    margin: 0.5rem 0;
    text-align: center;
  }

  .red {
    color: #f00;
  }

  .info {
    font-size: 0.3rem;
    line-height: 0.4rem;
    text-indent: 2em;
  }
}

.post-style {
  padding-bottom: 0.4rem;
  text-align: centerpadding-bottom0 0.4remtext -align;
}
</style>
